<div>
    <h2>{{ 'users.user-profile.authentication.title' | translate }}</h2>

    <div class="authentication">
        <div>
            <a href="{{ changePasswordUrl }}" target="_blank" class="primary-link">
                {{ 'users.user-profile.authentication.change-password' | translate }}
            </a>
        </div>
        <div *ngIf="showResendWelcomeEmail">
            <a (click)="resendWelcomeMail()" class="primary-link resend-welcome-mail-link">
                {{ 'users.user-profile.authentication.resend-welcome-mail.title' | translate }}
            </a>
        </div>
    </div>
</div>